import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type {SxProps} from '@mui/system';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';

//TYPES
type Props = {
  onNavigate: () => void;
};

const NotFound: FC<Props> = ({onNavigate}) => {
  const {t} = useTranslation();

  return (
    <Box sx={styles.container}>
      <Stack direction="row" spacing={2} sx={{alignItems: 'center', mb: 2}}>
        <ErrorOutlineIcon sx={styles.icon} />
        <Typography variant="h2" gutterBottom sx={{...styles.text, color: 'secondary.main'}}>
          404
        </Typography>
      </Stack>
      <Typography variant="h5" gutterBottom sx={styles.text}>
        {t('404.pageNotFound')}
      </Typography>
      <Typography variant="h6" sx={styles.text}>
        {t('404.pageNotFoundMessage')}
      </Typography>
      <Button sx={styles.button} variant="contained" onClick={onNavigate}>
        {t('404.goHome')}
      </Button>
    </Box>
  );
};
export default NotFound;

const styles: Record<string, SxProps> = {
  container: {
    bgcolor: 'transparent',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    m: 4,
    bgcolor: 'common.white',
    color: 'primary.main',
    fontWeight: 700,
  },
  icon: {
    fontSize: 50,
    color: 'secondary.main',
    mb: 2,
  },
  text: {
    color: 'common.white',
    textAlign: 'center',
  },
  logo: {
    position: 'absolute',
    bottom: 8,
    left: 8,
  },
};
